import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.darkViolet,
  anchorLink: colors.petsuitesGreen
};
export default anchor;